import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
    debug: process.env.NODE_ENV !== 'production',
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false,
    },
    resources: {
        // English
        en: {
            translation: {
                calendar: {
                    more: 'More',
                    moreHint: 'Show {{count}} more events',
                    today: 'Today',
                    allday: 'All Day',
                    timezone: {
                        label: 'Event time zone',
                        labelDropdown: 'Timezone',
                        localTime: 'local time',
                    },
                    message: {
                        noEvents: 'No Events are present in this timeframe',
                        noSearch: 'No results match your search',
                    },
                    appointmentType: 'Appointment type', // used by old Event Details - remove later
                    to: 'to', // used by old Event Details - remove later
                    filter: {
                        label: 'Filter',
                        showMore: 'Show More',
                        showLess: 'Show Less',
                        search: 'Search',
                        apply: 'Apply',
                        clear: 'Clear All',
                        events: 'Events',
                        teams: 'Teams',
                        venues: 'Venues',
                    },
                    view: {
                        month: 'Month',
                        week: 'Week',
                        day: 'Day',
                        list: 'List',
                    },
                    eventStatus: {
                        label: 'Event status', // used by old Event Details - remove later
                        new: 'New',
                        toBeConfirmed: 'To be confirmed',
                        updated: 'Updated',
                        tentative: 'Tentative',
                        confirmed: 'Confirmed',
                        postponed: 'Postponed',
                        canceled: 'Canceled',
                    },
                    eventType: {
                        committeeMeeting: 'Committee Meeting',
                        draw: 'Draw',
                        event: 'Event',
                        familiarisation: 'Familiarisation',
                        fifaCouncilMeeting: 'FIFA Council Meeting',
                        match: 'Match',
                        md1PressConference: 'MD-1 Press Conference',
                        md1TrainingSession: 'MD-1 Training Session',
                        mediaBriefing: 'Media Briefing',
                        meeting: 'Meeting',
                        pressConference: 'Press Conference',
                        restDay: 'Rest Day',
                        trainingSession: 'Training Session',
                        transportation: 'Transportation',
                        mediaOpportunity: 'Media Opportunity',
                        fifaFanFestival: 'FIFA Fan Festival',
                    },
                    noticeMessage:
                        'Notice: Every effort is made to ensure that the information presented in the calendar is correct and up to date. Teams sometimes alter their plans so times and/or locations are subject to change without notice', // used by old Event Details - remove later
                },
            },
        },
        // Spanish
        es: {
            translation: {
                calendar: {
                    more: 'Más',
                    moreHint: 'Mostrar {{count}} eventos más',
                    today: 'Presente',
                    allday: 'Todo el día',
                    timezone: {
                        label: 'Huso horario del evento',
                        labelDropdown: 'Huso horario',
                        localTime: 'hora local',
                    },
                    message: {
                        noEvents: 'No hay eventos en ese horario',
                        noSearch: 'No hay resultados que se correspondan con la búsqueda',
                    },
                    filter: {
                        label: 'Filtro',
                        showMore: 'Mostrar más',
                        showLess: 'Mostrar menos',
                        search: 'Buscar',
                        apply: 'Filtrar',
                        clear: 'Borrar todo',
                        events: 'Eventos',
                        teams: 'Equipos',
                        venues: 'Sedes',
                    },
                    view: {
                        month: 'Mes',
                        week: 'Semana',
                        day: 'Día',
                        list: 'Lista',
                    },
                    eventStatus: {
                        new: 'Nuevo',
                        toBeConfirmed: 'Por confirmar',
                        updated: 'Actualizado',
                        tentative: 'Provisional',
                        confirmed: 'Confirmado',
                        postponed: 'Aplazado',
                        canceled: 'Cancelado',
                    },
                    eventType: {
                        committeeMeeting: 'Sesión de una comisión',
                        draw: 'Sorteo',
                        event: 'Evento',
                        familiarisation: 'Familiarización de estadio',
                        fifaCouncilMeeting: 'Sesión del Consejo de la FIFA',
                        match: 'Partido',
                        md1PressConference: 'Rueda de prensa la víspera del partido',
                        md1TrainingSession: 'Sesión de entrenamiento la víspera del partido',
                        mediaBriefing: 'Sesión informativa para los medios',
                        meeting: 'Reunión',
                        pressConference: 'Rueda de prensa',
                        restDay: 'Jornada de descanso',
                        trainingSession: 'Entrenamiento',
                        transportation: 'Traslado',
                        mediaOpportunity: 'Interacción con los medios',
                        fifaFanFestival: 'FIFA Fan Festival™',
                    },
                },
            },
        },
        // French
        fr: {
            translation: {
                calendar: {
                    more: 'Plus',
                    moreHint: 'Afficher {{count}} événements supplémentaires',
                    // eslint-disable-next-line quotes
                    today: "Aujourd'hui",
                    allday: 'Toute la journée',
                    timezone: {
                        // eslint-disable-next-line quotes
                        label: "Fuseau horaire de l'événement",
                        labelDropdown: 'Fuseau horaire',
                        localTime: 'heure locale',
                    },
                    message: {
                        noEvents: 'Aucun événement sur cette période',
                        noSearch: 'Aucun résultat ne correspond à votre recherche',
                    },
                    filter: {
                        label: 'Filtre',
                        showMore: 'Voir plus',
                        showLess: 'Masquer',
                        search: 'Rechercher',
                        apply: 'Confirmer',
                        clear: 'Tout effacer',
                        events: 'Événements',
                        teams: 'Équipes',
                        venues: 'Sites',
                    },
                    view: {
                        month: 'Mois',
                        week: 'Semaine',
                        day: 'Jour',
                        list: 'Liste',
                    },
                    eventStatus: {
                        new: 'Nouveau',
                        toBeConfirmed: 'À confirmer',
                        updated: 'Actualisé',
                        tentative: 'Provisoire',
                        confirmed: 'Confirmé',
                        postponed: 'Reporté',
                        canceled: 'Annulé',
                    },
                    eventType: {
                        committeeMeeting: 'Séance de commission',
                        draw: 'Tirage au sort',
                        event: 'Événement',
                        familiarisation: 'Familiarisation du Stade',
                        fifaCouncilMeeting: 'Séance du Conseil de la FIFA',
                        match: 'Match',
                        md1PressConference: 'Conférence de presse de veille de match',
                        md1TrainingSession: 'Séance d’entraînement de veille de match',
                        mediaBriefing: 'Point presse',
                        meeting: 'Réunion',
                        pressConference: 'Conférence de presse',
                        restDay: 'Jour de repos',
                        trainingSession: 'Séance d’entraînement',
                        transportation: 'Transport',
                        mediaOpportunity: 'Opportunité médias',
                        fifaFanFestival: 'FIFA Fan Festival',
                    },
                },
            },
        },
        // Portuguese
        pt: {
            translation: {
                calendar: {
                    more: 'Mais',
                    moreHint: 'Mostrar outros {{count}} eventos',
                    today: 'Hoje',
                    allday: 'O dia todo',
                    timezone: {
                        label: 'Fuso horário do evento',
                        labelDropdown: 'Fuso horário',
                        localTime: 'Horário local',
                    },
                    message: {
                        noEvents: 'Não há eventos nesse período',
                        noSearch: 'Nenhum resultado corresponde à sua pesquisa',
                    },
                    filter: {
                        label: 'Filtro',
                        showMore: 'Mostrar mais',
                        showLess: 'Mostrar menos',
                        search: 'Pesquisar',
                        apply: 'Aplicar',
                        clear: 'Limpar tudo',
                        events: 'Eventos',
                        teams: 'Equipes',
                        venues: 'Estádios',
                    },
                    view: {
                        month: 'Mês',
                        week: 'Semana',
                        day: 'Dia',
                        list: 'Lista',
                    },
                    eventStatus: {
                        new: 'Novo',
                        toBeConfirmed: 'A confirmar',
                        updated: 'Atualizado',
                        tentative: 'Provisório',
                        confirmed: 'Confirmado',
                        postponed: 'Adiado',
                        canceled: 'Cancelado',
                    },
                    eventType: {
                        committeeMeeting: 'Reunião do comitê',
                        draw: 'Sorteio',
                        event: 'Evento',
                        familiarisation: 'Familiarização com o estádio',
                        fifaCouncilMeeting: 'Reunião do Conselho da FIFA',
                        match: 'Jogo',
                        md1PressConference: 'Coletiva de imprensa (véspera do dia de jogo (MD-1))',
                        md1TrainingSession: 'Treino (véspera do dia de jogo (MD-1))',
                        mediaBriefing: 'Sessão informativa para a imprensa',
                        meeting: 'Reunião',
                        pressConference: 'Coletiva de imprensa',
                        restDay: 'Dia de descanso',
                        trainingSession: 'Treino',
                        transportation: 'Transporte',
                        mediaOpportunity: 'Oportunidade para a mídia',
                        fifaFanFestival: 'FIFA Fan Festival',
                    },
                },
            },
        },
        // Arabic
        ar: {
            translation: {
                calendar: {
                    more: 'المزيد',
                    moreHint: 'عرض {{count}} فعاليات إضافية',
                    today: 'اليوم',
                    allday: 'كل اليوم',
                    timezone: {
                        label: 'المنطقة الزمنية للفعالية',
                        labelDropdown: 'المنطقة الزمنية',
                        localTime: 'التوقيت المحلي',
                    },
                    message: {
                        noEvents: 'لا توجد أحداث في هذا الإطار الزمني',
                        noSearch: 'لا توجد نتائج مطابقة لبحثك',
                    },
                    filter: {
                        label: 'الفلاتر',
                        showMore: 'إظهار نتائج إضافية',
                        showLess: 'إظهار نتائج أقل',
                        search: 'بحث',
                        apply: 'طبِّق',
                        clear: 'مسح كلّ الفلاتر',
                        events: 'الفعّاليات',
                        teams: 'الفرق',
                        venues: 'أماكن الفعاليات',
                    },
                    view: {
                        month: 'الشهر',
                        week: 'الأسبوع',
                        day: 'اليوم',
                        list: 'قائمة',
                    },
                    eventStatus: {
                        new: 'جديدة',
                        toBeConfirmed: 'سيتم تحديدها لاحقاً',
                        updated: 'محدَّثة',
                        tentative: 'متوقّعة',
                        confirmed: 'مؤكَّدة',
                        postponed: 'مؤجَّلة',
                        canceled: 'ملغاة',
                    },
                    eventType: {
                        committeeMeeting: 'اجتماع لجنة',
                        draw: 'قرعة',
                        event: 'الفعالية',
                        familiarisation: 'زيارة تعريفية',
                        fifaCouncilMeeting: 'اجتماع مجلس FIFA',
                        match: 'مباراة',
                        md1PressConference: 'المؤتمر الصحفي في اليوم السابق للمباراة',
                        md1TrainingSession: 'حصة التدريب في اليوم السابق للمباراة',
                        mediaBriefing: 'إحاطة إعلامية',
                        meeting: 'اجتماع',
                        pressConference: 'مؤتمر صحفي',
                        restDay: 'يوم راحة',
                        trainingSession: 'حصة تدريبية',
                        transportation: 'نقل',
                        mediaOpportunity: 'فرصة إعلامية',
                        fifaFanFestival: 'مهرجان FIFA للمشجعين',
                    },
                },
            },
        },
    },
});

export default i18n;
